import React, { useMemo } from "react";
import clsx from "clsx";
import CustomSelect from "../Select/CustomSelect";
import useMainFilter from "../../hooks/useMainFilter";
import useFilteredTransactions from "../../hooks/useFilteredTransactions";
import { MdDateRange, MdWarning } from "react-icons/md";
import { ICON_SIZES } from "../../helpers/constants";
import userPreferencesStore from "../../store/userPreferences";
import useAccountLocalStorage from "../../hooks/useAccountLocalStorage";
import { useTranslation } from "react-i18next";

const ReportsYearSelector: React.FC = () => {
  const { t } = useTranslation();
  const { isMainFilterActive } = useMainFilter();
  const { uniqueYears } = useFilteredTransactions();
  const { updateAccountLocalStorage } = useAccountLocalStorage();

  const { selectedYear, setSelectedYear } = userPreferencesStore(
    (state: any) => ({
      selectedYear: state.selectedYear,
      setSelectedYear: state.setSelectedYear,
    })
  );

  const yearsObject = useMemo(() => {
    const availableYears =
      uniqueYears?.map((year: any) => ({ value: year, label: year })) || [];

    return [
      ...availableYears,
      {
        value: "",
        label: t("year_selector.all_years"),
      },
    ];
  }, [uniqueYears]);

  // useEffect(() => {
  // if (!selectedYear || !uniqueYears?.includes(selectedYear)) {
  // if (uniqueYears?.length > 0) {
  // setSelectedYear(uniqueYears[0]);
  // } else {
  // setSelectedYear("");
  //   }
  // }
  // }, [selectedYear, uniqueYears, setSelectedYear]);

  return (
    <div
      className={clsx([
        "flex",
        "w-full",
        "flex-col",
        "md:flex-row",
        "items-center",
        "gap-4",
        "md:gap-4",
      ])}
    >
      <div
        className={clsx([
          "flex",
          "flex-row",
          "gap-2",
          "items-start",
          "w-full",
          "md:w-2/3",
        ])}
      >
        {yearsObject?.length ? (
          <MdDateRange size={ICON_SIZES.MD} className="shrink-0 opacity-100" />
        ) : (
          <MdWarning size={ICON_SIZES.MD} className="shrink-0 opacity-100" />
        )}
        <div className={clsx(["text-xs", "md:text-sm", "opacity-100"])}>
          {isMainFilterActive ? (
            <>
              {yearsObject?.length > 1 ? (
                <>{t("year_selector.filtered_multiple_years_message")}</>
              ) : (
                <>
                  {yearsObject?.length ? (
                    <>{t("year_selector.filtered_one_year_message")}</>
                  ) : (
                    <>{t("year_selector.filtered_no_results")}</>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {yearsObject?.length > 1 ? (
                <>{t("year_selector.multiple_years_message")}</>
              ) : (
                <>
                  {yearsObject?.length ? (
                    <>{t("year_selector.one_year_message")}</>
                  ) : (
                    <>{t("year_selector.no_transactions_message")}</>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
      <div className={clsx("flex w-full md:w-1/3")}>
        <CustomSelect
          isSearchable={false}
          options={yearsObject}
          disabled={yearsObject?.length <= 1}
          value={selectedYear as string}
          onChange={(e) => {
            updateAccountLocalStorage({ lastYear: e?.value || "" });
            setSelectedYear(e?.value);
          }}
          label={t("year_selector.label")}
          placeholder={t("year_selector.all_years")}
        />
      </div>
    </div>
  );
};

export default React.memo(ReportsYearSelector);
